import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { getOwnBreadcrumbLabel } from '@core/services/breadcrumb.service';

@Injectable({ providedIn: 'root' })
export class MumuPageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(routerState: RouterStateSnapshot) {
    // v22 paramsInheritanceStrategy 預設 always：最深 route 的 data 含繼承值
    // 改由 root 往下取「最深有自身定義」的 breadcrumb（own-label rule），與繼承策略脫鉤
    let route: ActivatedRouteSnapshot | null = routerState.root;
    let label: string | undefined;
    while (route) {
      const own = getOwnBreadcrumbLabel(route);
      if (own !== undefined) {
        label = own;
      }
      route = route.firstChild;
    }
    if (label !== undefined) {
      this.title.setTitle(`${label} | MuMuCare`);
    }
  }
}
